import React, { FC } from 'react';
import { shouldPioritizeComponentResources } from '../../../utils/component.utils';
import Picture from '../../@shared/picture';
import { TMediaImage } from '../types/herocarousel.types';

const MediaImage: FC<TMediaImage> = (props) => {
  const { id, dataSource, desktopSlideImage, tabletSlideImage, mobileSlideImage, altText, prioritizeSlide, sitecoreContext } = props;
  const placeholderData = sitecoreContext?.route?.placeholders['jss-main'] || [];

  return (
    <Picture
      editorialImageProps={{
        id: id ?? dataSource,
        desktopImage: desktopSlideImage,
        tabletImage: tabletSlideImage,
        mobileImage: mobileSlideImage,
        desktopTransformation: 'Size1900',
        tabletTransformation: 'Size1200',
        mobileTransformation: 'Size1200',
        alt: altText,
        cssClassImageEl: 'slide__image',
        prioritize: prioritizeSlide === 0 && shouldPioritizeComponentResources(placeholderData, 'HeroBanner'),
      }}
    />
  );
};

export default MediaImage;
